module.exports = __webpack_public_path__ + "static/Background-mp-2.738fae94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background-mp-2.jpg
// module id = 112
// module chunks = 133428282160390 225901961288281